import { Box } from "@material-ui/core"
import { ReactNode } from "react"

export function LineChartTopButtonsLayout({
  children,
}: {
  children: ReactNode
}) {
  return (
    <Box display="flex" alignItems="center">
      {children}
    </Box>
  )
}
